import { useDrawer } from '../Drawer';
import PrimaryButton, { PrimaryButtonProps } from './PrimaryButton';

type Props = Omit<PrimaryButtonProps, 'onClick'>;

export default function DrawerButton(props: Props) {
  const { toggle } = useDrawer();
  return <PrimaryButton onClick={toggle} {...props} />;
}
